export default [
    {
        name: 'cloudsColorTexture',
        type: 'texture',
        path: 'textures/clouds/color.png'
    },
    {
        name: 'cloudsAlphaTexture',
        type: 'texture',
        path: 'textures/clouds/alpha.png'
    },
    {
        name: 'floorColorTexture',
        type: 'texture',
        path: 'textures/floor/color.png'
    },
    {
        name: 'floorNormalTexture',
        type: 'texture',
        path: 'textures/floor/normal.png'
    },
    {
        name: 'marioColorTexture',
        type: 'texture',
        path: 'textures/mario/color.jpg'
    },
    {
        name: 'marioNormalTexture',
        type: 'texture',
        path: 'textures/mario/NormalMap.jpg'
    },
    {
        name: 'marioAlphaTexture',
        type: 'texture',
        path: 'textures/mario/alpha.jpg'
    },
    {
        name: 'marioShadowTexture',
        type: 'texture',
        path: 'textures/mario/simpleShadow.jpg'
    },
    {
        name: 'cubeModel',
        type: 'gltfModel',
        path: 'models/Dice/dice.glb'
    }
]